import React, { FC } from 'react';
import SummaryCashMulti from '../../../../../presentational/prices/multiCurrency/cash/summaryCash/SummaryCashMulti';
import IPrice from '../../../../../../../gqlCommon/model/prices/IPrice';

export interface IMultiCurrencyCashContainerProps {
  isLoading: boolean;
  primaryPrice: IPrice;
  secondaryPrice: IPrice;
  onIndicativeClick: () => void;
}

const MultiCurrencyCashContainer: FC<IMultiCurrencyCashContainerProps> = ({
  onIndicativeClick,
  isLoading,
  primaryPrice,
  secondaryPrice,
}) => {
  return (
    <SummaryCashMulti
      primaryTotal={primaryPrice}
      secondaryTotal={secondaryPrice}
      isLoading={isLoading}
      onIndicativeClick={onIndicativeClick}
    />
  );
};

export default MultiCurrencyCashContainer;
